import React, { useState, useEffect, useContext } from 'react';
import { Search } from 'lucide-react';
import { CartContext } from '../CartContext';
import ProductCard from './ProductCard';
import AddToCartModal from './AddToCartModal';

export default function ProductListPage({ user }) {
  const { addToCart } = useContext(CartContext);
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    if (!user?.name) return;

    const apiUrl = `https://posservice.revampapps.com/GetItemList?user=${encodeURIComponent(user.name)}`;

    fetch(apiUrl)
      .then(res => res.json())
      .then(data => {
        const fetchedItems = data?.GetItemListjs?.Table || [];
        const formatted = fetchedItems.map(item => ({
          id: item.itemid,
          partno: item.item_no,
          name: item.Item_desc1,
          price: item.standardcost ?? 0,
          image: sanitizeImageUrl(item.filepath),
        }));
        setProducts(formatted);
      })
      .catch(error => console.error('Fetch error:', error));
  }, [user]);

  const sanitizeImageUrl = (url) => {
    if (!url) return 'https://placehold.co/400x400?text=No+Image';
    try {
      const cleanPath = url.replace(/^http:\/\/\/?/, 'http://');
      return cleanPath.startsWith('http') ? cleanPath : `http://${cleanPath}`;
    } catch {
      return 'https://placehold.co/400x400?text=Invalid+Image';
    }
  };

  const filteredProducts = products.filter(product =>
    product.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="container mx-auto">
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-extrabold text-green-900 mb-2">
          🌱 Explore Our Green Collection
        </h1>

        <p className="text-lg text-gray-600">
          From vibrant flowers to fruit trees — discover nature’s best, ready for your garden.
        </p>
      </div>
      <div className="mb-8 max-w-lg mx-auto">
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
            <Search className="h-5 w-5 text-gray-400" />
          </div>
          <input
            type="text"
            placeholder="Search for Florals..."
            className="w-full p-4 pl-12 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-teal-500 transition-shadow duration-300 shadow-sm"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {filteredProducts.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProducts.map(product => (
            <ProductCard
              key={product.id}
              product={product}
              onAddToCartClick={() => setSelectedProduct(product)}
            />
          ))}
        </div>
      ) : (
        <div className="text-center py-16">
          <p className="text-xl text-gray-500">No Floral found matching your search.</p>
        </div>
      )}

      {selectedProduct && (
        <AddToCartModal
          product={selectedProduct}
          onAddToCart={addToCart}
          onClose={() => setSelectedProduct(null)}
        />
      )}

    </div>
  );
}
